<div *ngIf="selectedTagType?.name === 'Calculated'">
  <form [formGroup]="formGroupTags" class="formDetils">

    <h4 *ngIf="isModelPage" class="note">
      <small><i class="info-message">Select tags against more than one Entities(CIs, Model)</i></small>
    </h4>

    <mat-form-field appearance="outline" *ngIf="isModelCreate">
      <mat-label>Select Model or CI</mat-label>
      <mat-select matNativeControl (selectionChange)="componentChanged($event.value)"
        formControlName="availableComponent">
        <div *ngIf="isModelPage">
          <mat-option [id]="model.value" [value]="model.value" *ngFor="let model of selectedModel">
            {{ model.name + ' (M)' }}
          </mat-option>
        </div>
        <mat-option [id]="entity.id" [value]="entity.componentInstanceId" *ngFor="let entity of allComponents">
          {{ entity.componentInstanceName + ' (CI)' }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div [ngClass]="{'disabled-hover': (isModelPage && !formGroupTags.get('availableComponent').value) }">
      <mat-form-field appearance="outline"
        [ngClass]="{'disable-field': (isModelPage && !formGroupTags.get('availableComponent').value) }">
        <mat-label> {{ trans.SelectTag | translate }}</mat-label>
        <mat-select matNativeControl (focusout)="onDropdownFocusOut()"
          (selectionChange)="onAvailableChanged($event.value)" formControlName="availableTag">
          <mat-option [id]="tag.id" [value]="tag.name" *ngFor="let tag of allTags">
            {{ tag.name }} &nbsp;&nbsp;&nbsp; ({{(tag.tagType === "Calculated") ? tag.calc_tag_config?.output_type :
            (tag.tagType | lowercase)}})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div [ngClass]="{'disabled-hover': (isModelPage && !formGroupTags.get('availableComponent').value) }">
      <mat-form-field appearance="outline"
        [ngClass]="{'disable-field': (isModelPage && !formGroupTags.get('availableComponent').value) }">
        <mat-label> {{ trans.SelectProperty | translate }}</mat-label>
        <mat-select matNativeControl (focusout)="onDropdownFocusOut()"
          (selectionChange)="onAvailableChanged($event.value)" formControlName="availableProp">
          <mat-option [id]="property.id" [value]="property.name" *ngFor="let property of allProperties">
            {{ property.name }} &nbsp;&nbsp;&nbsp; ({{(property.propertyType | lowercase)}})
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div [ngClass]="{'disabled-hover': (isModelPage && !formGroupTags.get('availableComponent').value) }">
      <mat-form-field appearance="outline"
        [ngClass]="{'disable-field': (isModelPage && !formGroupTags.get('availableComponent').value) }">
        <mat-label>{{ trans.SelectAggregation | translate }}</mat-label>
        <mat-select matNativeControl (focusout)="onDropdownFocusOut()"
          (selectionChange)="onAvailableChanged($event.value)" formControlName="availableAggr">
          <mat-option [id]="aggregation.id" [value]="aggregation.name" *ngFor="let aggregation of allAggregations">
            {{ aggregation.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>{{ trans.CalculatedTags | translate }}</mat-label>
      <textarea matInput id="c1" (focusout)="onTextAreaFocusOut(textareaRef)" type="text"
        style="width: 375px; height: 230px;" required formControlName="calculated" autocomplete="off" #textareaRef>
</textarea>
    </mat-form-field>
    <button mat-raised-button [disabled]="formGroupTags.invalid || isAssetPage" style="float: right" color="primary"
      (click)="evalExecute(textareaRef)"> {{ trans.Validate | translate }}
      <mat-icon>check_circle</mat-icon>
    </button>
    <br />
    <!-- {{ expressionResult }} -->
  </form>
</div>
<div *ngIf="itemsCalculatedResult?.length">
  <h4 style="margin-top: 40px; text-align: left;"><b>  {{ trans.SelectTag | translate }}:</b></h4>
  <table class="custom-table-inputs">
    <tr *ngFor="let tagCalculatedresult of itemsCalculatedResult; let i = index" class="list-group list-group-flush">
      <td class="col-md-6 col-12">
        {{tagCalculatedresult.name}}
      </td>
      <td class="col-md-6 col-12">
        {{tagCalculatedresult.value}}
      </td>
    </tr>
  </table>
</div>
<div *ngIf="itemsDetail?.length">
  <h4 style="margin-top: 10px; text-align: left;"><b>{{ trans.Inputs | translate }}:</b></h4>
  <table class="custom-table-inputs">
    <!-- <th>Tag Name</th>
  <th>Value</th> -->
    <tr *ngFor="let tagDetail of itemsDetail; let i = index" class="list-group list-group-flush">
      <td class="col-md-6 col-12">
        {{ tagDetail.name +' '+ tagDetail.itemType }}
      </td>
      <td class="col-md-6 col-12">
        {{tagDetail.value}}
      </td>
    </tr>
  </table>
</div>